/* This is the EMIS Extra entrollment for primary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="870" cellspacing="0px;">
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                width: 160px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              ឈ្មោ៖គ្រូបង្រៀន
            </td>
            <td
              style="
                width: 60px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              វេន
            </td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ១</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ២</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៣</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៤</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៥</td>
            <td class="row-header" colspan="2">ថ្នាក់ទី ៦</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in 4" :key="row">
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              <v-text-field
                class="ttext my-0 px-1"
                outline
                hide-details
                v-model="data[row].name"
              />
            </td>
            <td
              style="
                width: 50px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              <v-select
                class="py-0 px-1"
                v-model="data[row].dt[0]"
                :items="g2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, row)"
              >
              </v-select>
            </td>
            <!-- get data from 1 to last -1 , Loop all -2 but in col must start from 1-->
            <td
              v-for="(value, col) in data[row].dt.length - 2"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].dt[col + 1]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { g2 } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      g2: g2,
    };
  },
  methods: {
    onSelect: function (event, row) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        this.data[row].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>


<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.row-data {
  width: 50px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>